import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserPermissionReducer } from '../reducers';

export const selectUserPermissionFeature = createFeatureSelector<UserPermissionReducer.DataState>(UserPermissionReducer.featureName);

export const selectFeatureUserPermission = createSelector(selectUserPermissionFeature, (state: UserPermissionReducer.DataState) => state.detail);
